import styled from 'styled-components'

const TooltipContentWrapper = styled.div`
  max-width: 194px;
`

export const s = { TooltipContentWrapper }
